import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../../components/layout";
import { Link } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Great, your apartment is old enough!`}</h1>
    <p>{`The other exceptions will affect a much smaller number or people.`}</p>
    <p>{`The next few exceptions are for situations where you have more specific housing protections applied to your home.`}</p>
    <p>{`Those include:`}</p>
    <ul>
      <li parentName="ul">{`Affordable housing`}</li>
      <li parentName="ul">{`A dorm owned by a higher education institution`}</li>
      <li parentName="ul">{`You are covered by even better rent control provisions under Costa Hawkins`}</li>
    </ul>
    <p>{`For more information about affordable housing and rent control, we have information about tenant resources in your county.`}</p>
    <Link to="/counties" mdxType="Link">I'd like more info!</Link>
    <br />
    <br />
    <p>{`Otherwise, we can move on to the next step.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      